import { Component, OnInit, ViewChild, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as XLSX from 'xlsx';
import { Constants, FILE_UPLOAD_TIMEOUT, generateRandomString } from 'src/app/constants';
import { HomeService } from 'src/app/service/home.service'
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { WebSocketService } from 'src/app/service/websocket.service';
import { catchError, EMPTY, takeWhile, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-import-template',
	templateUrl: './import-template.component.html',
	styleUrls: ['./import-template.component.scss'],
	standalone: false
})
export class ImportTemplateComponent implements OnInit {
	gridOptions: any;
	gridApi: any;
	selected_period_id;
	templateFile: any;
	columnDefs;
	rowData = [];
	successMessage = '';
	errorMessage = '';
	context: any;
	gridColumnApi: any;
	@ViewChild('agGrid', { static: true }) agGrid;
	arrayBuffer: any;
	isSuccess = false;
	dragAreaClass = 'droparea';
	isValidFile: boolean;
	userId
	selectedFileName: any;
	selectedFilePath: any;

	constructor(private readonly templatesService: HomeService,
		public dialogRef: MatDialogRef<ImportTemplateComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private readonly eboiStateService: EboiStateService,
		private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly constants: Constants, private readonly webSocketService: WebSocketService) {
		this.context = {
			componentParent: this
		};
		this.columnDefs = [
			{
				headerName: "", width: 5, autoHeight: true, wrapText: true,
				cellRenderer: (params) => {
					if (params.data.isError == "0") // NOSONAR
					{
						return '<mat-icon class="mat-icon material-icons" style="color:yellow" role="img">warning</mat-icon>'
					}
					else
					{
						return '<mat-icon class="mat-icon material-icons" style="color:red" role="img">cancel</mat-icon>'
					}
				}
			},
			{
				headerName: "ROW", width: 25, autoHeight: true, wrapText: true, field: "row"
			},
			{
				headerName: "COLUMN", width: 30, autoHeight: true, wrapText: true, field: "column"
			},
			{
				headerName: "FIELD(S)", width: 60, autoHeight: true, wrapText: true, field: "field"
			},
			{
				headerName: "VALUE", width: 60, autoHeight: true, wrapText: true, field: "value"
			},
			{
				headerName: "MESSAGE", width: 90, autoHeight: true, wrapText: true, field: "message"
			}
		]

		this.gridOptions = {
			suppressCellSelection: true,
			context: this.context,
		}
	}

	ngOnInit(): void {
		this.selected_period_id = this.data.selected_period
		const userData = sessionStorage?.getItem('FGA');
		if (userData) {
			this.userId = JSON.parse(userData)?.user?.userPrincipalName;
		}
	}

	onClick(event) {
		event.target.value = '';
	}

	onFileSelected(event) {
		if (event.target.files.item(0)) {
			this.templateFile = event.target.files.item(0);
			this.validateFile();
			const parsedFileName = this.templateFile?.name
				?.replace(/\s+/g, '_') // Replace spaces with underscore
				?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
			this.selectedFileName = `${generateRandomString()}_${parsedFileName}`;
			this.selectedFilePath = `EBOI/Import/${this.selectedFileName}`;
		}
	}

	fileChange(event) {
		if (event.target.files.item(0)) {
			this.templateFile = event.target.files.item(0);
			this.validateFile();
		}
	}

	importFile() {
		if (this.templateFile) {
			this.validateFile();
			if (!this.isValidFile) {
				this.isSuccess = false;
				this.errorMessage = 'Please select valid file';
				this.successMessage = '';
				this.resetMessages();
				return;
			}
			this.ngxUiLoaderService.start(this.constants.LoaderComponent);
			this.rowData = [];
			this.templatesService.uploadExcelFileData(this.templateFile, this.userId).subscribe(data => {
				const tempResponse = JSON.parse(data)
				const ifItsSuccess = tempResponse.findIndex(x => x.message == "SUCCESS"); // NOSONAR
				if (ifItsSuccess >= 0) {
					if (tempResponse.length == 2) { // NOSONAR
						this.rowData = JSON.parse(data);
						const displayRowIndex = this.rowData.findIndex(x => x.message == "SUCCESS") // NOSONAR
						this.rowData.splice(displayRowIndex, 1);
					}
					this.isSuccess = true;
					this.successMessage = this.constants.APIDataSaved;
					setTimeout(() => {
						this.successMessage = "";
						this.errorMessage = "";
					}, this.constants.notificationMessageTime);
				}
				else {
					this.isSuccess = false;
					if (tempResponse.length > 0 && tempResponse[0]?.row == null) { // NOSONAR
						this.errorMessage = tempResponse[0]?.message;
						setTimeout(() => {
							this.successMessage = "";
							this.errorMessage = "";
						}, this.constants.notificationMessageTimeShort)
					} else {
						this.rowData = JSON.parse(data);
						this.gridApi?.setGridOption('rowData', this.rowData);
						this.errorMessage = 'Validation Failed. Please find Error details below.';
						this.successMessage = '';
					}
				}
				this.resetMessages();
				this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
			}, error => {
				console.info(error)
				this.isSuccess = false;
				this.errorMessage = 'Something went wrong. Please contact your system administrator';
				this.successMessage = '';
				this.resetMessages();
				this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
			});
		} else {
			this.errorMessage = "Please select the file first";
			setTimeout(() => {
				this.successMessage = "";
				this.errorMessage = "";
			}, this.constants.notificationMessageTime);
		}
	}

	async newimportFile() {
		if (this.templateFile) {
			this.validateFile();
			if (!this.isValidFile) {
				this.isSuccess = false;
				this.errorMessage = 'Please select valid file';
				this.successMessage = '';
				this.resetMessages();
				return;
			}
			this.ngxUiLoaderService.start(this.constants.LoaderComponent);
			this.rowData = [];
			try {
				this.webSocketService.connect();
				await this.webSocketService.waitUntilSocketConnected();
				console.info(
					'WebSocket connected:',
					this.webSocketService.isSocketConnected()
				);
				this.webSocketService.sendMessage(
					// JSON.stringify({
					{ fileName: this.selectedFilePath }
					// })
				);
				const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePath}`;
				const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
				const upn = fgaDetails?.user?.userPrincipalName;

				const uploadHeaders: any = {
					'Content-Type': this.templateFile?.type, // Set file content type
					'x-auth-token': sessionStorage.getItem('accessToken'),
					'x-amz-meta-userid': upn

				};

				const response = await fetch(url, {
					method: 'PUT',
					headers: uploadHeaders,
					body: this.templateFile,
				});

				if (!response.ok) {
					this.ngxUiLoaderService.stop(this.constants.LoaderComponent);; // 🛑 Stop spinner on error
					this.errorMessage = 'Failed to upload file!'
					this.resetMessages()
					this.webSocketService.closeConnection();
					return;
				}

				this.webSocketService
					.receiveMessages()
					.pipe(
						// If no message is received within 25 seconds, throw TimeoutError
						timeout({
							each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
						}),
						takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ), // NOSONAR
						catchError((err) => {
							if (err.name == 'TimeoutError') { // NOSONAR
								console.info(
									`No message received in ${FILE_UPLOAD_TIMEOUT / 1000
									} seconds. Closing connection.`
								);
								this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
								this.webSocketService.closeConnection();
								this.errorMessage = 'Failed to upload file. Please re-upload the file.'
								this.resetMessages()
							} else {
								console.info('WebSocket error:', err);
							}
							return EMPTY; // Stop further emissions
						})
					)
					.subscribe((messages: any) => {
						console.info(messages, "messages from Lambda");

						const backendResp = messages.backendResponse;
						try {
							if (backendResp) {
							// Check backend API response for success/failure
							const tempResponse = JSON.parse(backendResp)
							const ifItsSuccess = tempResponse.findIndex(x => x.message == "SUCCESS"); // NOSONAR
							if (ifItsSuccess >= 0) {
								if (tempResponse.length == 2) { // NOSONAR
									this.rowData = JSON.parse(backendResp);
									const displayRowIndex = this.rowData.findIndex(x => x.message == "SUCCESS") // NOSONAR
									this.rowData.splice(displayRowIndex, 1);
								}
								this.isSuccess = true;
								this.successMessage = this.constants.APIDataSaved;
								setTimeout(() => {
									this.successMessage = "";
									this.errorMessage = "";
								}, this.constants.notificationMessageTime);
							}
							else {
								this.isSuccess = false;
								if (tempResponse.length > 0 && tempResponse[0]?.row == null) { // NOSONAR
									this.errorMessage = tempResponse[0]?.message;
									setTimeout(() => {
										this.successMessage = "";
										this.errorMessage = "";
									}, this.constants.notificationMessageTimeShort)
								} else {
									this.rowData = JSON.parse(backendResp);
									this.gridApi?.setGridOption('rowData', this.rowData);
									this.errorMessage = 'Validation Failed. Please find Error details below.';
									this.successMessage = '';
								}
							}
							this.resetMessages();
							this.ngxUiLoaderService.stop(this.constants.LoaderComponent);

						}
						}
						catch {
							this.isSuccess = false;
							this.errorMessage = 'Something went wrong. Please contact your system administrator';
							this.successMessage = '';
							this.resetMessages();
							this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
						}

						
						this.webSocketService.closeConnection();
					})
			} catch (err) {
				this.isSuccess = false;
				console.info('Unexpected upload exception:', err);
				this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
				this.webSocketService.closeConnection();
				this.errorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists'
			}
		} else {
			this.errorMessage = "Please select the file first";
			setTimeout(() => {
				this.successMessage = "";
				this.errorMessage = "";
			}, this.constants.notificationMessageTime);
		}
	}

	resetMessages() {
		setTimeout(() => {
			this.successMessage = '';
			this.errorMessage = '';
		}, this.constants.notificationMessageTime);
	}
	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}

	sizeToFit() {
		this.gridApi.sizeColumnsToFit();
	}

	closeDialog(): void {
		this.dialogRef.close({ status: this.isSuccess });
	}

	validateFile() {

		if (!this.templateFile) {
			this.isValidFile = false;
		}
		const fileReader = new FileReader();
		fileReader.onload = _e => {
			this.arrayBuffer = fileReader.result;
			const data = new Uint8Array(this.arrayBuffer);
			const arr = [];
			for (let i = 0; i <= data.length; i++) {
				arr[i] = String.fromCharCode(data[i]);
			}
			const bstr = arr.join("");
			const workbook = XLSX.read(bstr, { type: "binary" })
			const firstSheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[firstSheetName];
			const excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
			if (excelData && excelData.length > 0) {
				this.isValidFile = true;
			} else {
				this.isValidFile = false;
			}
		}
		fileReader.readAsArrayBuffer(this.templateFile);
	}

	@HostListener('dragover', ['$event']) onDragOver(event) {
		this.dragAreaClass = 'droparea';
		event.preventDefault();
	}
	@HostListener('drop', ['$event']) onDrop(event) {
		this.dragAreaClass = 'droparea';
		event.preventDefault();
		event.stopPropagation();
		this.templateFile = event.dataTransfer.files.item(0);
	}

}
